import React from 'react'
import './css/about.css'
function About({ motion }) {
    return (
        <div className='right-section about background'>
            <span id="hello">Hello,</span>
            <span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 1 }}>I'm Akash</span>
            <br></br>
            <div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5, duration: 1 }} className='about-me'>
                <span>a <span id='full-stack'>Full-Stack </span>Web Developer located in New Delhi.</span>

                <span id='passion'>Have a great passion for web designing, animations, servers and APIs.
                    <br></br>
                    A well organized and productive person great at problem solving,
                    <br></br>
                    currently pursing Bachelor's Degree at Delhi University.
                </span>
                <br></br>
                My Skills
                <div className='skill-container'>
                    <div className='frontend'>
                        <img src='https://img.shields.io/badge/HTML5-E34F26?style=for-the-badge&logo=html5&logoColor=white' alt='html' />
                        <img src='https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=css3&logoColor=white' alt='css' />
                        <img src='https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black' alt='js' />
                        <img src='https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB' alt='react' />
                    </div>
                    <div className='backend'>
                        <img src='https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white' alt='nodejs' />
                        <img src='https://img.shields.io/badge/Express.js-404D59?style=for-the-badge' alt='express' />
                        <img src='https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white' alt='mongodb' />
                    </div>
                </div>
                <span id='hobbies'>
                    I've always been fascinated by Computers and Internet, and for
                    <br></br>
                    me nothing is more fun than to convert my ideas into webpages.
                    <br></br>
                    My hobbies are video games, music, anime and reading.
                </span>
                <span id='future'>
                    I am interested in starting my own company in the future :{")"}
                </span>

            </div>
        </div>
    )
}

export default About

// import React from 'react'
// import './css/about.css'
// function About({ motion }) {
//     return (
//         <motion.div initial={{ opacity: 0, y: 100 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -100 }} transition={{ delay: 0.6, duration: 0.5 }} className='right-section about'>
//             <span id="hello">Hello,</span>
//             <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1, duration: 1 }}>I'm Akash</motion.span>
//             <br></br>
//             <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5, duration: 1 }} className='about-me'>
//                 <span>a <span id='full-stack'>Full-Stack </span>Web Developer located in New Delhi.</span>

//                 <span id='passion'>Have a great passion for web designing, animations, servers and APIs.
//                     <br></br>
//                     A well organized and productive person great at problem solving,
//                     <br></br>
//                     currently pursing Bachelor's Degree at Delhi University.
//                 </span>
//                 <br></br>
//                 My Skills
//                 <div className='skill-container'>
//                     <div className='frontend'>
//                         <img src='https://img.shields.io/badge/HTML5-E34F26?style=for-the-badge&logo=html5&logoColor=white' alt='html' />
//                         <img src='https://img.shields.io/badge/CSS3-1572B6?style=for-the-badge&logo=css3&logoColor=white' alt='css' />
//                         <img src='https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black' alt='js' />
//                         <img src='https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB' alt='react' />
//                     </div>
//                     <div className='backend'>
//                         <img src='https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white' alt='nodejs' />
//                         <img src='https://img.shields.io/badge/Express.js-404D59?style=for-the-badge' alt='express' />
//                         <img src='https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white' alt='mongodb' />
//                     </div>
//                 </div>
//                 <span id='hobbies'>
//                     I've always been fascinated by Computers and Internet, and for me nothing is more fun than to convert my ideas into webpages.
//                     My hobbies are video games, music, anime and reading.
//                 </span>
//                 <span id='future'>
//                     I am interested in starting my own company in the future :{")"}
//                 </span>

//             </motion.div>
//         </motion.div>
//     )
// }

// export default About